module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.svg?8f152a8689fc774f8fb8b67383c9b478";